(function () {
  'use strict';
  var launcher = document.getElementById('wx-accessibility-launcher');
  if (!launcher) return;
  var status = document.getElementById('wx-accessibility-status');
  var selector = '#wx-accessibility-launcher, [id="accessibility-icon"], #accessibility-icon-mobile, [data-uw-trigger="true"]';
  var loading = false;
  var wanted = false;
  var timer;
  var ownedScript;

  function ready() {
    if (!window.UserWay || typeof window.UserWay.widgetOpen !== 'function') return false;
    clearTimeout(timer);
    loading = false;
    launcher.removeAttribute('aria-busy');
    status.textContent = '';
    if (wanted) {
      wanted = false;
      window.UserWay.widgetOpen();
    }
    return true;
  }
  function failed() {
    clearTimeout(timer);
    loading = false;
    launcher.removeAttribute('aria-busy');
    status.textContent = 'Accessibility options could not load. Please try again.';
    if (ownedScript) { ownedScript.remove(); ownedScript = null; }
  }
  function open() {
    wanted = true;
    if (ready() || loading) return;
    loading = true;
    launcher.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading accessibility options.';
    // Yield so pressing the launcher can paint before initializing the SDK.
    requestAnimationFrame(function () {
      setTimeout(function () {
        if (ready()) return;
        if (!document.querySelector('script[src*="cdn.userway.org/widget.js"]')) {
          ownedScript = document.createElement('script');
          ownedScript.src = 'https://cdn.userway.org/widget.js';
          ownedScript.async = true;
          ownedScript.setAttribute('data-account', 'GtXw3fkKZF');
          ownedScript.onerror = failed;
          document.head.appendChild(ownedScript);
        }
        timer = setTimeout(function () { if (!ready()) failed(); }, 20000);
      }, 0);
    });
  }
  document.addEventListener('userway:init_completed', ready);
  document.querySelectorAll(selector).forEach(function (element) {
    if (element.tagName !== 'BUTTON') {
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-label', 'Open accessibility options');
    }
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('keydown', function (event) {
    var target = event.target.closest && event.target.closest(selector);
    if (!target || target.tagName === 'BUTTON' || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
})();
